import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { NgCnafCommonsModule } from '@cnaf/ng-cnaf-commons';
import { CollapseModule  } from 'ngx-bootstrap/collapse';

import { CnafCommonsMonCompteAppliModule, TagXitiService as TagCommonXitiService } from '@cnaf/cnaf-commons-mon-compte-appli';
import { AppComponent } from './app.component';
import { ContacterMaCafCompletComponent } from './01-contactermacaf-complet/contactermacafcomplet.component';
import { ContacterMaCafCompletWebComponent } from './01-contactermacaf-complet/contactermacafcomplet.component-web';
import { ContacterMaCafCompletMobileComponent } from './01-contactermacaf-complet/contactermacafcomplet.component-mobile';
import { ContacterCafPrimoCourrielComponent } from './05-contactermacaf-primoparcourriel/contactercafprimocourriel.component';
import { ContacterCafCourrielComponent } from './03-contactermacaf-parcourriel/contactercafcourriel.component';
import { AppRoutingModule } from './app-routing.module';
import { TagXitiService } from './services/tagxiti.service';
import { ContacterCafVousAvezDesQuestionsComponent } from './06-contactermacaf-vousavezdesquestions/contactercafvousavezdesquestions.component';
import { SafeUrlPipe } from './pipes/safeurl.pipe';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { GlobalPubSubService } from './services/globalpubsub.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContacterCafCamilleHeaderComponent } from './09-contactermacaf-camilleheader/contactermacafcamilleheader.component';
import { ContacterCafCourrielReponsesComponent } from './10-contactermacaf-reponses/contactercafcourrielreponses.component';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { CnafAfficheArticle } from './directive/cnaf-affiche-article.directive';
import { ContacterMaCafSviComponent } from './contactermacaf-svi/contactermacafsvi.component';
import { ContacterMaCafEchecSviComponent } from './contactermacaf-echec-svi/contactermacaf-echec-svi.component';
import { ContactermacafMotifsdecontactComponent } from './contactermacaf-motifsdecontact/contactermacaf-motifsdecontact.component';
import { MotifsdecontactDettesComponent } from './contactermacaf-motifsdecontact/parcours/dettes/motifsdecontact-dettes.component';
import { MotifsdecontactActualitesComponent } from './contactermacaf-motifsdecontact/parcours/actualites/motifsdecontact-actualites.component';
import { MotifsdecontactAutremotifComponent } from './contactermacaf-motifsdecontact/parcours/autremotif/motifsdecontact-autremotif.component';
import { MotifsdecontactChangementDeSituationComponent } from './contactermacaf-motifsdecontact/parcours/changementdesituation/motifsdecontact-changementdesituation.component';
import { MotifsdecontactDelaisDeTraitementComponent } from './contactermacaf-motifsdecontact/parcours/delaisdetraitement/motifsdecontact-delaisdetraitement.component';


@NgModule({
  declarations: [
    AppComponent,
    ContacterMaCafCompletComponent,
    ContacterMaCafCompletWebComponent,
    ContacterMaCafCompletMobileComponent,
    ContacterCafPrimoCourrielComponent,
    ContacterCafCourrielComponent,
    ContacterMaCafSviComponent,
    ContacterMaCafEchecSviComponent,
    ContacterCafVousAvezDesQuestionsComponent,
    SafeUrlPipe,
    ContacterCafCamilleHeaderComponent,
    ContacterCafCourrielReponsesComponent,
    CnafAfficheArticle,
    SafeHtmlPipe,
    ContactermacafMotifsdecontactComponent,
    MotifsdecontactDettesComponent,
    MotifsdecontactActualitesComponent,
    MotifsdecontactAutremotifComponent,
    MotifsdecontactChangementDeSituationComponent,
    MotifsdecontactDelaisDeTraitementComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgCnafCommonsModule,
    CollapseModule.forRoot(),
    CnafCommonsMonCompteAppliModule,
    TypeaheadModule.forRoot(),
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: ''
    },
    TagXitiService,
    TagCommonXitiService,
    GlobalPubSubService
  ],
  exports : [
    ContacterCafVousAvezDesQuestionsComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule{
}
